import React from "react";
import Card from '../../../components/card/card';
import { AccessPointsList } from './compositions/accessPointsList';

export function CoreAccessPoints() {
  return (
    <div className="core-access-points-list-container core-access-points-card_sizing">
      <Card noPadding={true}>
        <div className="core-access-points">
          <div className="core-access-points_list">
            <AccessPointsList />
          </div>
        </div>
      </Card>
    </div>
  );
}
